module.exports = __webpack_public_path__ + "img/aeroland-branding-image-10.8672fd5d.png";